<wo-supplier-input
  data-e2e="supplier filter list"
  [formControl]="control.control"
  [placeholder]="'iss-wo-common.label.all-suppliers' | translate"
  [multi]="true"
  [withAll]="true"
/>
